import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NbCheckboxModule } from '@nebular/theme';

@Component({
	selector: 'formly-nebular-checkbox',
	template: `
		<nb-checkbox standalone [formControl]="formControl" status="primary">
			{{ field.key }}
		</nb-checkbox>
	`,
	imports: [ReactiveFormsModule, NbCheckboxModule]
})
export class FormlyNebularCheckboxTypeComponent extends FieldType<FieldTypeConfig> {}
